import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/tocht/";

const TochtApi = {
	getNieuw() {
		const serviceUrl = prependRoot(routePrefix + "getNieuw", getApiRoot());

		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	saveTocht(tochtToSave) {
		const serviceUrl = prependRoot(routePrefix + "/aanmaken", getApiRoot());
		return axios.put(serviceUrl,
			tochtToSave, {
			headers: {
				accept: "application/json"
			}
		});
	},

	getAllByOrganisator() {
		const serviceUrl = prependRoot(
			routePrefix + "/organisator",
			getApiRoot()
		);
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	deleteTocht(tochtId) {
		const serviceUrl = prependRoot(
			routePrefix + "/delete/" + tochtId,
			getApiRoot()
		);
		return axios.delete(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	getTochtenByOrganisator() {
		const listByUrl = prependRoot(
			routePrefix + "getTochtenByOrganisator",
			getApiRoot()
		);
		return axios.get(listByUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	getKopieerbareTochtenByOrganisator() {
		const listByUrl = prependRoot(
			routePrefix + "getKopieerbareTochtenForOrganisator",
			getApiRoot()
		);
		return axios.get(listByUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	getTochtenInAfwachtingByOrganisator(provincieId) {
		const listByUrl = prependRoot(routePrefix + "getTochtenInAfwachtingByOrganisator/" + provincieId, getApiRoot());
		return axios.get(listByUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},

	getAllByGemeente() {
		const serviceUrl = prependRoot(
			"tocht/getall/gemeente",
			getApiRoot()
		);
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	getTochtGemeente(tochtId) {
		const serviceUrl = prependRoot(
			"tocht/" + tochtId + "/gemeente",
			getApiRoot()
		);
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	get(tochtId) {
		const serviceUrl = prependRoot("/tocht/" + tochtId, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	getNewDeelnamePrijs(tochtId) {
		const serviceUrl = prependRoot(
			"/tocht/" + tochtId + "/deelnameprijs/new",
			getApiRoot()
		);
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	updateTochtenInAfwachting(tochtenInAfwachtingToSave) {
		const serviceUrl = prependRoot(routePrefix + '/updateTochtenInAfwachting', getApiRoot());
		return axios.put(serviceUrl, tochtenInAfwachtingToSave,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},

	getClone(tochtId) {
		const serviceUrl = prependRoot(routePrefix + 'clone/' + tochtId, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},

	getNewLus(tochtId) {
		const serviceUrl = prependRoot(
			"/tocht/" + tochtId + "/lus/new",
			getApiRoot()
		);
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	save(model, documents) {
		const serviceUrl = prependRoot("tocht", getApiRoot());
		return axios.put(
			serviceUrl,
			{
				item: model,
				documenten: documents
			},
			{
				headers: {
					accept: "application/json"
				}
			}
		);
	},

	getLegeContactPersoon() {
		const serviceUrl = prependRoot(routePrefix + '/legecontactpersoon', getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},

	genereerPDF(tochtId) {
		const serviceUrl = prependRoot(routePrefix + "genereerPDF", getApiRoot());
		return axios.post(
			serviceUrl,
			{
				tochtId: tochtId
			},
			{
				headers: {
					accept: "application/json"
				}
			}
		);
	},

	genereerGemeentePDF(tochtId) {
		const serviceUrl = prependRoot(routePrefix + "genereerGemeentePDF", getApiRoot());
		return axios.post(
			serviceUrl,
			{
				tochtId: tochtId
			},
			{
				headers: {
					accept: "application/json"
				}
			}
		);
	}
};

export default TochtApi;
